import React from 'react'
import './Projects.css'
import {Swiper, SwiperSlide} from 'swiper/react'
import SA from "../../img/SA.jpg"
import PE from "../../img/PE.jpg"
import F from "../../img/F.jpg"
import TN from "../../img/TN.jpg"
import Waves from "../../img/Waves.jpg"
import TheCall from "../../img/TheCall.jpg"
import TheChoice from "../../img/TheChoice.jpg"
import TheWay from "../../img/TheWay.jpg"
import TheEscape from "../../img/TheEscape.jpg"
import TheCalm from "../../img/TheCalm.jpg"
import POWER from "../../img/POWER.jpg"
import ALIVE from "../../img/ALIVE.png"
import TheSaint from "../../img/TheSaint.jpg"
import Faithful from "../../img/Faithful.jpg"
import HopeFrontCover from "../../img/HopeFrontCover.png"
import HopeBackCover from "../../img/HopeBack Cover.png"
import SafeSpaceFront from "../../img/SafeSpaceFront.png"
import SafeSpaceBack from "../../img/SafeSpaceBack.png"
import FaithPack from "../../img/FaithPack.jpg"
import IOM from "../../img/IOM.jpg"
import KM from "../../img/KM.jpg"
import vinyl from "../../img/vinyl.png"
import "swiper/css"

const projectSlides = [
    { id: 'faithpack', title: 'Faith Pack', link: 'https://fanlink.tv/KUSHIM-FAITHPACK', image: FaithPack },
    { id: 'IOM', title: 'Instruments Of Meditation', link: 'https://fanlink.tv/KUSHIM-InstrumentsOfMeditation', image: IOM },
    { id: 'KM', title: 'Faith Pack', link: 'https://fanlink.tv/KUSHIM-KingdomMission', image: KM },
  { id: 'set-apart', title: 'Set Apart', link: 'https://fanlink.tv/KUSHIM-SETAPART', image: SA },
  { id: 'a-party-in-eden', title: 'A Party In Eden', link: 'https://fanlink.tv/KUSHIM-APartyInEden', image: PE },
  { id: 'waves', title: 'Waves', link: 'https://fanlink.tv/KUSHIM-Waves', image: Waves },
  { id: 'the-new', title: 'The New', link: 'https://fanlink.tv/KUSHIM-THENEW', image: TN },
  { id: 'freedom', title: 'Freedom', link: 'https://fanlink.tv/KUSHIM-FREEDOM', image: F },
  { id: 'the-call', title: 'The Call', link: 'https://fanlink.tv/KUSHIM-TheCall', image: TheCall },
  { id: 'the-choice', title: 'The Choice', link: 'https://fanlink.tv/KUSHIM-TheChoice', image: TheChoice },
  { id: 'the-escape', title: 'The Escape', link: 'https://fanlink.tv/KUSHIM-TheEscape', image: TheEscape },
  { id: 'the-way', title: 'The Way', link: 'https://fanlink.tv/KUSHIM-TheWay', image: TheWay },
  { id: 'the-calm', title: 'The Calm', link: 'https://fanlink.tv/KUSHIM-TheCalm', image: TheCalm },
  { id: 'power', title: 'Power', link: 'https://fanlink.tv/KUSHIM-POWER', image: POWER },
  { id: 'the-saint', title: 'The Saint', link: 'https://fanlink.tv/KUSHIM-TheSaint', image: TheSaint },
  { id: 'faithful', title: 'Faithful', link: 'https://fanlink.tv/KUSHIM-Faithful', image: Faithful },
  { id: 'alive', title: 'Alive', link: 'https://fanlink.tv/KUSHIM-ALIVE', image: ALIVE },
]

const Projects = () => {
  return (
    <div className='projects'>
        {/* heading */}
        <span>Some Recent</span>
        <span>Projects</span>

        {/* heading */}
        <Swiper
        spaceBetween={50}
        slidesPerView={4}
        grabCursor={true}
        className="projects-slider">

            <SwiperSlide>
                <div className='project-card project-card--placeholder project-card--active'>
                    <a href='https://fanlink.tv/KUSHIM-sAFesPACe' target="_blank" rel="noopener noreferrer" className='project-card__link'>
                        <div className='project-card__inner'>
                            <div className='project-card__face project-card__face--front'>
                                <img className='project-card__image' src={SafeSpaceFront} alt='SafeSpace Front Cover' loading='lazy' />
                            </div>
                            <div className='project-card__face project-card__face--back project-card__face--cover'>
                                <img className='project-card__image project-card__image--back' src={SafeSpaceBack} alt='SafeSpace Back Cover' loading='lazy' />
                            </div>
                        </div>
                    </a>
                </div>
            </SwiperSlide>

            <SwiperSlide>
                <div className='project-card project-card--placeholder project-card--active'>
                    <a href='https://fanlink.tv/KUSHIM-HOPE' target="_blank" rel="noopener noreferrer" className='project-card__link'>
                        <div className='project-card__inner'>
                            <div className='project-card__face project-card__face--front'>
                                <img className='project-card__image' src={HopeFrontCover} alt='Hope Front Cover' loading='lazy' />
                            </div>
                            <div className='project-card__face project-card__face--back project-card__face--cover'>
                                <img className='project-card__image project-card__image--back' src={HopeBackCover} alt='Hope Back Cover' loading='lazy' />
                            </div>
                        </div>
                    </a>
                </div>
            </SwiperSlide>

            {projectSlides.map((project) => (
                <SwiperSlide key={project.id}>
                    <div className='project-card'>
                        <a href={project.link} target="_blank" rel="noopener noreferrer" className='project-card__link'>
                            <div className='project-card__inner'>
                                <div className='project-card__face project-card__face--front'>
                                    <img className='project-card__image' src={project.image} alt={project.title} loading="lazy" />
                                </div>
                                <div
                                    className='project-card__face project-card__face--back'
                                    style={{ backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.25), rgba(0,0,0,0.6)), url(${vinyl})` }}
                                >
                                    <span>{project.title}</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </SwiperSlide>
            ))}

        </Swiper>
    </div>
  )
}

export default Projects